import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type TrackCopiedShareLinkParams = {
  id: string;
  shareId: string;
  type: 'clip' | 'board' | 'collection' | 'canvas';
  location: AirActionTrackingLocation;
};

export const useTrackCopiedShareLink = () => {
  const { track } = useAnalyticsUtilities();

  const trackCopiedShareLink = useCallback(
    (params: TrackCopiedShareLinkParams) => {
      track(`Copied a share url`, params, { integrations: { 'Customer.io (Actions)': true, Intercom: true } });
    },
    [track],
  );

  return { trackCopiedShareLink };
};
